import { IconDocumentSmall } from '@amzn/stencil-react-icons';

/**
 * The document glyph, used to mark a surface that lists recorded work.
 *
 * Thin by design. It exists so the glyph has one home rather than being imported
 * directly by each feature that wants it — which is what the shared-pattern rule
 * asks for, and what makes a later change of glyph a one-file edit.
 *
 * Decorative: the surfaces that use it carry a visible title, and Stencil's icons
 * set `aria-hidden` themselves.
 */
export function DocumentDisplay(): JSX.Element {
  return <IconDocumentSmall />;
}
